<script setup>
const props = defineProps([
  "services",
  "selectedService",
  "selectedSlotsNumber",
  "serviceSlotNumber",
  "id",
  "name",
  "dataYupLabel",
  "ariaControls",
  "ariaExpanded",
  "ariaLabelledby"
]);
defineEmits(["change"]);
</script>
<template>
    <div class="select-wrapper mt-5">
      <label :for="`${props.id}`"> Seleziona il motivo dell'appuntamento</label>
      <select
        :id="props.id"
        :name="props.name"
        :value="props.selectedService"
        :data-yup-label="props.dataYupLabel"
        :aria-controls="ariaControls"
        :aria-expanded="ariaExpanded"
        :aria-labelledby="ariaLabelledby"
        @change="
          (e) => {
            $emit('change', e.target.value);
          }
        "
      >
        <option selected="" value="">Seleziona opzione</option>
        <option
          v-for="service in props.services"
          :key="service.serviceId"
          :value="service.serviceId"
        >
          {{ service.description }}
        </option>
      </select>
    </div>
</template>
